// React / Redux / Related
import React, { Component } from 'react';
import get from 'lodash.get';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { I18n, Translate } from 'react-redux-i18n';
import { withRouterV6 as withRouter } from '../../../helpers/withRouterV6.jsx';
import { capitalizeCamelCase } from '../../../helpers/stringUtils';
import { bindActionCreators } from 'redux';
import { Icon } from 'semantic-ui-react';

// Actions
import * as programActions from '../store/vipProgramActions';

// Components
import ListsViewContainer from './listview';
import ContextMenu from '../../../components/common/grid/contextMenu';
import { Common } from '../../../components';
import clear from '../../../components/clear';
import BasePage from '../../../components/common/basePageView';
import { Record } from '../../../modules/bin/utility';
import { ConfirmRegistrationModal } from '../confirmRegistrationModal';
import { ProgramAnnouncementBanner } from './components/programAnnouncementBanner';
import { withPageTitle } from '../../../hocs';

// Constants
import config from '../../../constants/index';
import { gridTabs, i18nKeys } from '../constants';
import { exportFileNames } from '../../../constants/exportFiles';

import { CONTEXT_MENU_KEYS } from '../../../constants/contextMenuEntries';
import { WriteOnly } from '../../../components/common/grid/WriteOnly.js';

// ----------------------------------------------------------------------

/** A page to view all campaigns in a list */
class CampaignAmbassadorView extends Component {
  constructor(props) {
    super(props);

    const campaignId = get(props, 'match.params.campaignId');

    props.getCampaignAmbassadorProgramByCampaignRecord(campaignId);

    props.getTotalCountApplications(
      'eventAmbassador/aggregate',
      'campaignId',
      campaignId
    );
    props.getTotalCountCampaignWaitlistApplications(
      'eventAmbassador/aggregate',
      'campaignId',
      campaignId
    );
    props.getTotalCountCampaignPendingProgramsNilRaisedByReceivedStatus(
      'eventAmbassador/aggregate',
      'campaignId',
      campaignId
    );
    props.getTotalCountCampaignPendingProgramsByReceivedStatus(
      'eventAmbassador/aggregate',
      'campaignId',
      campaignId
    );
    props.getTotalCountVIPProgramsByClaimedStatus(
      'eventAmbassador/aggregate',
      'campaignId',
      campaignId
    );
    props.getTotalCountVIPProgramsByAcceptedStatus(
      'eventAmbassador/aggregate',
      'campaignId',
      campaignId
    );
  }

  getCampaignApplicationsContextMenu = () => {
    return (
      <ContextMenu>
        <ContextMenu.Item
          key={CONTEXT_MENU_KEYS.PROGRAM.EDIT_APPLICATION.key}
          label={I18n.t('campaignApplications.list.context.view-application')}
          contextMenuOptions={CONTEXT_MENU_KEYS.PROGRAM.EDIT_APPLICATION}
        />
        <ContextMenu.Item
          key={CONTEXT_MENU_KEYS.PROGRAM.VIEW_FUNDRAISER.key}
          label={I18n.t('campaignApplications.list.context.view-fundraiser')}
          contextMenuOptions={CONTEXT_MENU_KEYS.PROGRAM.VIEW_FUNDRAISER}
          isHiden={(item) => !Boolean(item.fundraiser)}
        />
      </ContextMenu>
    );
  };

  getCampaignWaitlistApplicationsContextMenu = () => {
    return (
      <ContextMenu>
        <ContextMenu.Item
          key={CONTEXT_MENU_KEYS.PROGRAM.EDIT_APPLICATION.key}
          label={I18n.t('campaignApplications.list.context.view-application')}
          contextMenuOptions={CONTEXT_MENU_KEYS.PROGRAM.EDIT_APPLICATION}
        />
        <ContextMenu.Item
          key={CONTEXT_MENU_KEYS.PROGRAM.VIEW_FUNDRAISER.key}
          label={I18n.t('campaignApplications.list.context.view-fundraiser')}
          contextMenuOptions={CONTEXT_MENU_KEYS.PROGRAM.VIEW_FUNDRAISER}
          isHiden={(item) => !Boolean(item.fundraiser)}
        />
      </ContextMenu>
    );
  };

  getCampaignPendingProgramsNilRaisedContextMenu = () => {
    return (
      <ContextMenu>
        <ContextMenu.Item
          key={CONTEXT_MENU_KEYS.PROGRAM.EDIT_APPLICATION.key}
          label={I18n.t('campaignApplications.list.context.view-application')}
          contextMenuOptions={CONTEXT_MENU_KEYS.PROGRAM.EDIT_APPLICATION}
        />
        <ContextMenu.Item
          key={CONTEXT_MENU_KEYS.PROGRAM.VIEW_FUNDRAISER.key}
          label={I18n.t('campaignApplications.list.context.view-fundraiser')}
          contextMenuOptions={CONTEXT_MENU_KEYS.PROGRAM.VIEW_FUNDRAISER}
          isHiden={(item) => !Boolean(item.fundraiser)}
        />
      </ContextMenu>
    );
  };

  getCampaignPendingProgramsContextMenu = () => {
    return (
      <ContextMenu>
        <ContextMenu.Item
          key={CONTEXT_MENU_KEYS.PROGRAM.EDIT_APPLICATION.key}
          label={I18n.t('campaignApplications.list.context.view-application')}
          contextMenuOptions={CONTEXT_MENU_KEYS.PROGRAM.EDIT_APPLICATION}
        />
        <ContextMenu.Item
          key={CONTEXT_MENU_KEYS.PROGRAM.VIEW_FUNDRAISER.key}
          label={I18n.t('campaignApplications.list.context.view-fundraiser')}
          contextMenuOptions={CONTEXT_MENU_KEYS.PROGRAM.VIEW_FUNDRAISER}
          isHiden={(item) => !Boolean(item.fundraiser)}
        />
      </ContextMenu>
    );
  };

  getCampaignVipProgramsContextMenu = () => {
    return (
      <ContextMenu>
        <ContextMenu.Item
          key={CONTEXT_MENU_KEYS.PROGRAM.EDIT_APPLICATION.key}
          label={I18n.t('campaignVipPrograms.list.context.view-application')}
          contextMenuOptions={CONTEXT_MENU_KEYS.PROGRAM.EDIT_APPLICATION}
        />
        <ContextMenu.Item
          key={CONTEXT_MENU_KEYS.PROGRAM.VIEW_FUNDRAISER.key}
          label={I18n.t('campaignVipPrograms.list.context.view-fundraiser')}
          contextMenuOptions={CONTEXT_MENU_KEYS.PROGRAM.VIEW_FUNDRAISER}
          isHiden={(item) => !Boolean(item.fundraiser)}
        />
        <ContextMenu.Item
          isHiden={item => get(item, "externalRegistration.isConfirmed")}
          key={CONTEXT_MENU_KEYS.PROGRAM.CONFIRM_REGISTRATION.key}
          label={I18n.t('campaignVipPrograms.list.context.confirm-registration')}
          contextMenuOptions={CONTEXT_MENU_KEYS.PROGRAM.CONFIRM_REGISTRATION}
          onClick={id => this.props.toggleConfirmRegistrationModal(id, true)}
        />
      </ContextMenu>
    );
  };

  onEditCampaignAmbassadorProgramClick = () => {
    const campaignId = get(this.props, 'match.params.campaignId');

    this.props.history.push(`/vip-program/campaign/edit/${campaignId}/setup`);
  };

  onViewApplicationFormClick = () => {
    const campaignAmbassadorUrlFull = get(
      this.props.campaignAmbassadorProgramRecord,
      'data.data.urlFull'
    );

    window.open(campaignAmbassadorUrlFull, '_blank');
  };

  /**
   * Renders the component
   */
  render() {
    const campaignId = get(this.props, 'match.params.campaignId');

    const baseFilter = {
      key: 'campaignId',
      operator: 'EqualTo',
      value: campaignId
    };

    const waitlistApplicationsFilters = [
      { key: 'campaignId', operator: 'EqualTo', value: campaignId },
      { key: 'status', operator: 'EqualTo', value: 'Waitlisted' }
    ];
    const vipProgramsFilters = [
      { key: 'campaignId', operator: 'EqualTo', value: campaignId },
      { key: 'status', operator: 'InList', value: ['Accepted', 'Claimed'] }
    ];
    const pendingProgramsNilRaisedFilters = [
      { key: 'campaignId', operator: 'EqualTo', value: campaignId },
      { key: 'status', operator: 'EqualTo', value: 'Received' },
      { key: 'fundraiser.raisedAmount', operator: 'EqualTo', value: '0' }
    ];
    const pendingProgramsFilters = [
      { key: 'campaignId', operator: 'EqualTo', value: campaignId },
      { key: 'status', operator: 'EqualTo', value: 'Received' },
      { key: 'fundraiser.raisedAmount', operator: 'GreaterOrEqualThan', value: '1' }
    ];

    const campaignAmbassadorData = get(
      this.props.campaignAmbassadorProgramRecord,
      'data.data'
    );

    const isLoading =
      Record.isRecordReady(this.props.campaignAmbassadorProgramRecord) &&
      Record.isRecordReady(this.props.totalCountApplicationsRecord) &&
      Record.isRecordReady(this.props.totalCountCampaignWaitlistApplicationsRecord) &&
      Record.isRecordReady(
        this.props.totalCountVIPProgramsByClaimedStatusRecord
      ) &&
      Record.isRecordReady(
        this.props.totalCountCampaignPendingProgramsNilRaisedByReceivedStatusRecord
      ) &&
      Record.isRecordReady(
        this.props.totalCountCampaignPendingProgramsByReceivedStatusRecord
      ) &&
      Record.isRecordReady(
        this.props.totalCountVIPProgramsByAcceptedStatusRecord
      );

    const campaignAmbassadorAvailability = get(campaignAmbassadorData, 'availability.newEntries');
    const campaignAmbassadorAllocatedSeats = get(campaignAmbassadorData, 'metrics.availableCount');
    const organizationName = get(campaignAmbassadorData, 'organization.name');
    const campaignName = get(campaignAmbassadorData, 'campaign.name');

    const campaignImage = get(campaignAmbassadorData, 'mainImagePath');
    const organizationImage = get(
      campaignAmbassadorData,
      'organization.mainImagePath'
    );

    const metrics = get(campaignAmbassadorData, 'metrics');
    const currency = get(campaignAmbassadorData, 'organization.currency');

    return (
      <BasePage>
        <ProgramAnnouncementBanner />
        <div>
          <Common.PageHeader
            loading={!isLoading}
            name={campaignName}
            image={organizationImage ? organizationImage : campaignImage}
            afterBreadcrumbs={
              <>
                <Icon
                  name="circle"
                  style={{
                    marginLeft: "1rem",
                    color: campaignAmbassadorAvailability ? "#56B68B" : "#757575"
                  }}
                />
                Applications {campaignAmbassadorAvailability ? "Open" : "Closed"}
                <span
                  style={{
                    marginLeft: "1rem",
                    fontWeight: 700,
                  }}
                >
                  {campaignAmbassadorAllocatedSeats} seat(s) allocated
                </span>
              </>
            }
            headerRightPanel={
              <div className="page-header-right-panel">
                <Common.Button onClick={this.onViewApplicationFormClick}>
                  <Translate value={i18nKeys.VIEW_APPLICATION_FORM} />
                </Common.Button>
                <WriteOnly>
                  <Common.Button
                    onClick={this.onEditCampaignAmbassadorProgramClick}
                  >
                    <Translate
                      value={i18nKeys.EDIT_PROGRAM_CAMPAIGN_VIEW_BUTTON}
                    />
                  </Common.Button>
                </WriteOnly>
              </div>
            }
          >
            <Link to={config.DEFAULT_PROGRAMS_URL} push>
              <Common.PageHeader.Breadcrumb
                label={I18n.t(i18nKeys.VIEW_LABEL)}
              />
            </Link>
            <Common.PageHeader.Breadcrumb label={organizationName} />
          </Common.PageHeader>
        </div>
        <ListsViewContainer
          baseFilter={baseFilter}
          filterPath="vip-program/campaign"
          metrics={metrics}
          currency={currency}
          applicationsGridKey={gridTabs.CAMPAIGN_APPLICATIONS}
          applicationsExportName={exportFileNames.CAMPAIGN_APPLICATIONS}
          applicationsExportEndpoint={'EventAmbassador'}
          applicationsContextMenu={this.getCampaignApplicationsContextMenu()}
          campaignWaitlistApplicationsGridKey={gridTabs.CAMPAIGN_WAITLIST_APPLICATIONS}
          campaignWaitlistApplicationsExportName={exportFileNames.CAMPAIGN_WAITLIST_APPLICATIONS}
          campaignWaitlistApplicationsExportEndpoint={'EventAmbassador'}
          campaignWaitlistApplicationsContextMenu={this.getCampaignWaitlistApplicationsContextMenu()}
          campaignWaitlistApplicationsFilters={waitlistApplicationsFilters}
          campaignPendingProgramsNilRaisedGridKey={
            gridTabs.CAMPAIGN_PENDING_PROGRAMS_NIL_RAISED
          }
          campaignPendingProgramsNilRaisedExportName={
            exportFileNames.CAMPAIGN_PENDING_PROGRAMS_NIL_RAISED
          }
          campaignPendingProgramsNilRaisedExportEndpoint={'EventAmbassador'}
          campaignPendingProgramsNilRaisedContextMenu={this.getCampaignPendingProgramsNilRaisedContextMenu()}
          campaignPendingProgramsNilRaisedFilters={pendingProgramsNilRaisedFilters}
          campaignPendingProgramsGridKey={
            gridTabs.CAMPAIGN_PENDING_PROGRAMS
          }
          campaignPendingProgramsExportName={
            exportFileNames.CAMPAIGN_PENDING_PROGRAMS
          }
          campaignPendingProgramsExportEndpoint={'EventAmbassador'}
          campaignPendingProgramsContextMenu={this.getCampaignPendingProgramsContextMenu()}
          campaignPendingProgramsFilters={pendingProgramsFilters}
          vipProgramsGridKey={gridTabs.CAMPAIGN_VIP_PROGRAMS}
          vipProgramsExportName={exportFileNames.CAMPAIGN_VIP_PRORGAMS}
          vipProgramsExportEndpoint={'EventAmbassador'}
          vipProgramsContextMenu={this.getCampaignVipProgramsContextMenu()}
          vipProgramsFilters={vipProgramsFilters}
        />
        <ConfirmRegistrationModal />
      </BasePage>
    );
  }
}

/** Maps the state to properties */
const mapState = (state) => {
  return {
    campaignAmbassadorProgramRecord:
      state.program.campaignAmbassadorProgramRecord,
    totalCountProgramsRecord: state.program.totalCountProgramsRecord,
    totalCountApplicationsRecord: state.program.totalCountApplicationsRecord,
    totalCountCampaignWaitlistApplicationsRecord: state.program.totalCountCampaignWaitlistApplicationsRecord,
    totalCountCampaignPendingProgramsNilRaisedByReceivedStatusRecord:
      state.program.totalCountCampaignPendingProgramsNilRaisedByReceivedStatusRecord,
    totalCountCampaignPendingProgramsByReceivedStatusRecord:
      state.program.totalCountCampaignPendingProgramsByReceivedStatusRecord,
    totalCountVIPProgramsByClaimedStatusRecord:
      state.program.totalCountVIPProgramsByClaimedStatusRecord,
    totalCountVIPProgramsByAcceptedStatusRecord:
      state.program.totalCountVIPProgramsByAcceptedStatusRecord
  };
};

/** Maps the actions to properties */
const mapDispatch = (dispatch) => {
  const dispatchers = bindActionCreators(programActions, dispatch);

  return dispatchers;
};

const titleResolver = (props) => {
  const campaignName = get(props, 'campaignAmbassadorProgramRecord.data.data.campaign.name', '');
  const tab = get(props, 'match.params.tab', '');
  const capitalizedTab = capitalizeCamelCase(tab);
  return I18n.t('page-titles.vip-programs.list-campaign', { campaignName, tab: capitalizedTab });
};

const CampaignAmbassadorViewWithTitle = withPageTitle(titleResolver)(CampaignAmbassadorView);

/** Connects component to Redux store */
const CampaignAmbassadorViewPageContainer = clear(
  withRouter(connect(mapState, mapDispatch)(CampaignAmbassadorViewWithTitle))
);
export default CampaignAmbassadorViewPageContainer;
